import { ROUTE_PATHS } from '../../routes/consts';
import { DEFAULT_STEP_INDEX } from './consts';

/**
 * Extracts the current step index from a URL pathname
 * @param pathname - The current URL pathname (e.g., "/onboarding/2")
 * @returns The zero-based index of the current step (e.g., for "/onboarding/2" returns 1)
 */
export const getCurrentStepIndex = (): number => {
  const urlParts = window.location.pathname.split('/').filter(Boolean);
  const parsedInt = parseInt(urlParts.pop() || '1');

  return isNaN(parsedInt) ? DEFAULT_STEP_INDEX : parsedInt - 1;
};

/**
 * Builds the URL for a specific step in the onboarding process
 * @param stepIndex - The step index to navigate to
 * @returns URL string for the specified step
 */
export const buildStepUrl = (stepIndex: number) => {
  return `/${ROUTE_PATHS.ONBOARDING}/${stepIndex + 1}`;
};

/**
 * Builds the URL for the next step in the onboarding process
 * @param stepIndex - The current step index
 * @returns URL string for the next step
 */
export const buildNextStepUrl = () => {
  const currentStepIndex = getCurrentStepIndex();

  return buildStepUrl(currentStepIndex + 1);
};

/**
 * Builds the URL for the previous step in the onboarding process
 * @param stepIndex - The current step index
 * @returns URL string for the previous step
 */
export const buildPreviousStepUrl = () => {
  const currentStepIndex = getCurrentStepIndex();

  return buildStepUrl(currentStepIndex - 1);
};
